import { Fighter } from ".";

export class PlayerFighter extends Fighter {
  constructor(
    isPlayer: boolean
  ) {
    super(isPlayer)
  }
}
